<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    
    <!-- 页面加载效果组件 -->
    <page-loading v-if="isLoading" :loading-style="loadingStyle" />
  </div>
</template>

<script>
import PageLoading from './components/PageLoading.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'App',
  components: {
    PageLoading
  },
  setup() {
    const isLoading = ref(false);
    const loadingStyle = ref('spinner'); // 可选值：spinner, pulse, dots
    const router = useRouter();
    
    // 监听路由变化，显示加载动画
    router.beforeEach((to, from, next) => {
      isLoading.value = true;
      
      // 从路由元数据中获取加载样式
      if (to.meta && to.meta.loadingStyle) {
        loadingStyle.value = to.meta.loadingStyle;
      } else {
        // 默认样式
        loadingStyle.value = 'spinner';
      }
      
      next();
    });
    
    router.afterEach(() => {
      // 延迟关闭加载动画，使过渡更平滑
      setTimeout(() => {
        isLoading.value = false;
      }, 500);
    });
    
    return {
      isLoading,
      loadingStyle
    };
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow-x: hidden;
  --content-margin-left: var(--menu-width); /* 添加全局变量定义内容区域左边距 */
}
</style>
